import {useState} from 'react';
import "./App.css";
import Clock from "./components/Clock";
import Weather from "./components/Weather";
import Schedule from "./components/Schedule";
import Reminder from "./components/Reminder";
import WeatherTip from "./components/WeatherTip";
import AdaptScreen from "./components/AdaptScreen";
import { useEffect } from "react";
function App() {
  const [count,setCount] = useState(1);
  useEffect(() =>{
    const timer = setInterval(() =>{
      setCount(count+1)
    },1000 * 60 * 60 )
    return () =>{
      clearInterval(timer);
    }
  })
  return (
    <AdaptScreen screenData={{screenWidth:3500,screenHeight:1990}}>
      <div className="app-container">
        <div className="bottom-container">
          <div className="left-panel">
            <Clock />
            <Reminder />
            <Weather key={count}  />
            <WeatherTip />
          </div>
          <div className="right-panel">
            <Schedule />
          </div>
        </div>
      </div>
    </AdaptScreen>
    
  );
}

export default App;
